import api from '@/utils/api';

export const config = {
  state: {
    current_ticker_id: null,
    currencies: [],
    multipliers: [],
    my_multipliers: [],
  },
  getters: {
    getCurrentTickerId(state: any) {
      return state.current_ticker_id;
    },
    getCurrentTicker(state: any, getters: any, _: any, rootGetters: any) {
      if (!state.current_ticker_id) return null;
      return rootGetters.getPossibleTickers[state.current_ticker_id];
    },
    currencies(state: any) {
      return state.currencies;
    },
    multipliers(state: any) {
      return state.multipliers;
    },
    my_multipliers(state: any) {
      return state.my_multipliers;
    },
  },
  mutations: {
    UPDATE_CURRENT_TICKER(state: any, data: any) {
      state.current_ticker_id = data;
    },
    SET_CURRENCIES(state: any, data: any) {
      state.currencies = data;
    },
    SET_MULTIPLIERS(state: any, data: any) {
      state.multipliers = data;
    },
    SET_MY_MULTIPLIERS(state: any, data: any) {
      state.my_multipliers = data;
    },
  },
  actions: {
    setCurrentTicker(context: any, payload: { id: number }) {
      context.commit('UPDATE_CURRENT_TICKER', payload.id);
    },
    async loadCurrencies(context: any) {
      await api({ url: '/currencies', data: {}, method: 'GET' })
        .then((response: any) => {
          if (response.data.list) {
            context.commit('SET_CURRENCIES', response.data.list.currentPageResult);
            return true;
          }
        });
    },
    async loadMultipliers(context: any) {
      await api({ url: '/balance-multiplier/available', data: {}, method: 'GET' })
        .then((response: any) => {
          if (response.data) {
            context.commit('SET_MULTIPLIERS', response.data);
            return true;
          }
        });
    },
    async loadUserMultipliers(context: any) {
      await api({ url: '/balance-multiplier/my', data: {}, method: 'GET' })
        .then((response: any) => {
          if (response.data) {
            context.commit('SET_MY_MULTIPLIERS', response.data);
            return true;
          }
        });
    }
  },
  modules: {
  }
}